export default __webpack_public_path__ + "static/media/prabu-face.1b05bc86.png";